import React from "react";
import { Link } from "react-router-dom";
import { AiOutlineArrowRight } from "react-icons/ai";
import { BsGithub } from "react-icons/bs";
import { CgWebsite } from "react-icons/cg";
import SectionHead from "../common/SectionHead";
import MediaCard from "../common/MediaCard";
import { projects } from "../../data/content";

function projectLinks(project) {
  const links = [{ href: project.repo, label: "GitHub", Icon: BsGithub }];
  if (project.demo) {
    links.push({ href: project.demo, label: "Demo", Icon: CgWebsite });
  }
  return links;
}

function FeaturedWork() {
  const featured = projects.filter((project) => project.featured);

  return (
    <section className="section" id="work">
      <div className="container">
        <SectionHead eyebrow="Work" title="Selected projects" />

        <div className="card-grid">
          {featured.map((project) => (
            <MediaCard
              key={project.title}
              image={project.image}
              title={project.title}
              description={project.description}
              links={projectLinks(project)}
            />
          ))}
        </div>

        <div className="section__footer">
          <Link to="/work" className="link-arrow">
            View all projects <AiOutlineArrowRight />
          </Link>
        </div>
      </div>
    </section>
  );
}

export { projectLinks };
export default FeaturedWork;
